module.exports = __webpack_public_path__ + "static/img/raas_build_4.77a9f05.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_build_4.svg
// module id = emQZ
// module chunks = 0